export const RELEASE_LINE = {
  angular: '11.2.x',
  packageVersion: '11.0.0',
  coreVersion: '0.1.1',
  runtimeTarget: 'Angular 11 + Angular CLI',
  docsPath: '/angular-11/'
};
